<template>
  <div class=" overflow-y-auto bg-gray-50 px-4 pt-6 mb-10" dir="rtl">
    <div class="max-w-2xl mx-auto flex flex-col">
      <!-- Request Header Card -->
      <div class="bg-gradient-to-r from-indigo-600 to-indigo-700 rounded-xl p-6 mb-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-14 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-lg font-bold">{{ request_info.RequestName || 'نام درخواست' }}</h2>
            <p class="text-sm text-indigo-50 font-mono mt-1">{{ request_info.RequestCode || 'شماره درخواست' }}</p>
          </div>
         
        </div>
      </div>

      <div ref="form">
        <div>
          <ul class="relative request_detail_ul">
            <li v-if="hasValue(request_info.LastStatus)" class="bg-indigo-50 border-indigo-200">
              <div class="flex items-center justify-between gap-3 w-full">
                <div class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0">
                  <svg class="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div class="w-full">
                  <label class="text-xs text-indigo-600 block mb-1">{{ $t('lastStatus') }}</label>
                  <span class="text-sm font-bold text-indigo-900 block">{{ request_info.LastStatus }}</span>
                </div>
                
              </div>
            </li>

            <li v-if="hasValue(request_info.RequestTime)">
              <label>{{ $t('registerDate') }}</label>
              <span>
                {{ request_info.RequestTime }}
              </span>
            </li>

           

            <li v-if="hasValue(request_info.Summary)">
              <label>{{ $t('description') }}</label>
              <span>
                {{ request_info.Summary }}
              </span>
            </li>

            <li v-if="hasValue(request_info.CustomerMobile)">
              <label>{{ $t('phoneNO') }}</label>
              <span>
                <a :href="'tel:'+request_info.CustomerMobile" class="text-blue-600">
                  {{ request_info.CustomerMobile }}
                </a>
              </span>
            </li>

            <li v-if="hasValue(request_info.OtherPhoneNO)">
              <label>{{ $t('secoundPhoneNo') }}</label>
              <span>
                {{ request_info.OtherPhoneCode }}{{ request_info.OtherPhoneNO }}
              </span>
            </li>

            <li v-if="hasValue(request_info.StatusSummary)">
              <label>{{ $t('referDescription') }}</label>
              <span>
                {{ request_info.StatusSummary }}
              </span>
            </li>

            <li v-if="safeParseArray(request_info.EjraiStatusSummary).length">
              <label>وضعیت های اجرائی</label>
              <div v-for="ejraii in safeParseArray(request_info.EjraiStatusSummary)" 
                   :key="ejraii.StatusName">
                {{ ejraii.StatusName }} : {{ ejraii.Summary }}
              </div>
            </li>

            <li v-if="!dialog_accept_refer && hasValue(request_info.Addresses)">
              <div class="pa-1">
                <label>{{ $t('addresses') }}</label>
                <div v-for="(item_address, index) in request_info.Addresses"
                     :key="index" class="">
                  <div class="address-text">{{ get_request_address(item_address) }}</div>
                  <div class="text-xs text-gray-500 mt-1" v-if="item_address.PhoneNO">
                    {{ item_address.PhoneCode }}{{ item_address.PhoneNO }}
                  </div>
                  <div v-if="item_address.FromTime !=null" class="text-xs text-gray-500 mt-1">
                    {{ item_address.FromTime }} - {{ item_address.ToTime }}
                  </div>
                  <div class="flex gap-2 mt-2">
                    <button v-if="item_address.Lat != null" 
                            class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" 
                            style="border: 1px solid rgb(83 128 239) !important"
                            @click="go_direction(item_address, 1)">
                      <img src="/img/svg/BaiduMap.svg" alt="Google Maps" class="w-5 h-5" />
                      <span class="text-sm">{{ $t('navigation') }}</span>
                    </button>
                    <button v-if="item_address.Lat != null" 
                            class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" 
                            style="border: 1px solid rgb(83 128 239) !important"

                            @click="go_direction(item_address, 2)">
                      <img src="/img/svg/Waze.svg" alt="Waze" class="w-5 h-5" />
                      <span class="text-sm">ویز</span>
                    </button>
                    <button v-if="item_address.Lat != null" 
                            class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" 
                            style="border: 1px solid rgb(83 128 239) !important"
                            @click="go_direction(item_address, 3)">
                      <img src="/img/svg/Neshan.svg" alt="Neshan" class="w-5 h-5" />
                      <span class="text-sm">نشان</span>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <!-- Confirmation Card -->
          <div v-if="showReferConfirmCard" class="inline-refer-card mb-10">
            <div class="inline-refer-header">درخواست ارجاعی</div>
            <div class="inline-refer-body">
              <div class="mb-2">آیا دریافت این درخواست ارجاعی را تایید می‌کنید؟</div>
              <div style="display: flex; gap: 8px; justify-content: center; align-items: center;">
                <button class="btn-accept" style="width: 50%" @click="onAcceptRefer()">قبول درخواست</button>
                <button class="btn-reject" style="width: 50%" @click="openConfirmationReject()">رد درخواست</button>
              </div>
            </div>
          </div>

        </div>
        <div>
          <!-- Action Buttons -->
          <div class="actions-grid" v-if="!showReferConfirmCard && request_confirmed">
            <button 
              @click="dialog_change_pre_req_status=true"
              class="primary-btn"
            >
              تغییر وضعیت درخواست
            </button>
            <button 
              v-if="action_button_text != ''"
              @click="go_to_categories()"
              class="primary-btn"
            >
              {{ action_button_text }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Reject Request Modal -->
    <div
      v-if="show_confirmation_reject_area"
      class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4"
      @click.self="cancelConfirmationReject()"
    >
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
        <div class="px-6 py-4 bg-gradient-to-r from-red-500 to-red-600">
          <h2 class="text-lg font-bold text-white text-center">رد درخواست</h2>
        </div>
        <div class="px-6 py-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            دلیل رد درخواست
            <span class="text-red-500">*</span>
          </label>
          <textarea
            v-model="confirmation_reject_summary"
            rows="4"
            required
            class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            :style="rejectSummaryInvalid
              ? 'border: 1px solid #ef4444 !important;'
              : 'border: 1px solid #d1d5db !important;'"
            placeholder="دلیل رد درخواست را وارد کنید (اجباری)"
          ></textarea>
          <p v-if="rejectSummaryInvalid" class="text-xs text-red-500 mt-2">وارد کردن توضیحات لغو اجباری است</p>
        </div>
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="!hasRejectSummary"
            @click="submitConfirmationReject()"
          >
            تایید
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="cancelConfirmationReject()"
          >
            انصراف
          </button>
        </div>
      </div>
    </div>

    <!-- Service Location Dialog -->
    <div v-if="dialog_service_out_branch" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-indigo-600 to-indigo-700">
          <h2 class="text-lg font-bold text-white text-center">{{ $t('requestStatus') }}</h2>
        </div>

        <!-- Body -->
        <div class="px-6 py-6">
          <p class="text-sm text-gray-700 text-center">{{ $t('isRequestInBranchOrNot') }}</p>
            </div>
        
        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button 
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="service_out_branch_action(8)"
          >
            {{ $t('inLocation') }}
          </button>
          <button 
            class="flex-1 px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="service_out_branch_action(7)"
          >
            {{ $t('inBranch') }}
          </button>
            </div>
          </div>
        </div>

    <!-- Change Status Dialog -->
    <div v-if="dialog_change_pre_req_status" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-indigo-600 to-indigo-700">
          <h2 class="text-lg font-bold text-white text-center">تغییر وضعیت درخواست</h2>
            </div>
        
        <!-- Body -->
        <div class="px-6 py-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">وضعیت</label>
            <select 
              v-model="selected_pre_req_status"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none relative"
              style="border: 1px solid #d1d5db !important;"
            >
                  <option :value="0" disabled>انتخاب وضعیت</option>
                  <option v-for="s in pre_req_status_list" :key="s.Id" :value="s.Id">{{ s.StateName }}</option>
                </select>
              </div>
              <div>
            <input 
              v-model="pre_req_status_summary" 
              placeholder="توضیحات وضعیت"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              style="border: 1px solid #d1d5db !important;"
            />
              </div>
            </div>
        
        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button 
            class="flex-1 px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="change_pre_request_status_tech()"
          >
            ثبت وضعیت
          </button>
          <button 
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="dialog_change_pre_req_status=false"
          >
            انصراف
          </button>
            </div>
          </div>
        </div>

    <!-- Invoice Type Dialog (before entering request info) -->
    <div v-if="dialog_invoice_type" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden max-h-[90vh] flex flex-col">
        <div class="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700">
          <h2 class="text-lg font-bold text-white text-center">نوع فاکتور را بپرسید</h2>
        </div>

        <div class="px-6 py-6 space-y-4 overflow-y-auto">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              نوع فاکتور را بپرسید
              <span class="text-red-500">*</span>
            </label>
            <p class="text-xs text-gray-500 mb-2">مسئولیت انتخاب فاکتور به عهده مشتری می باشد.</p>
            <div class="relative">
              <select
                v-model="invoiceType"
                class="w-full px-4 pr-4 pl-10 py-3 border border-gray-300 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
                style="border: 1px solid #d1d5db !important;"
              >
                <option value="">انتخاب کنید</option>
                <option value="unofficial">غیر رسمی</option>
                <option value="official">رسمی</option>
              </select>
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          <div v-if="invoiceType === 'official'" class="space-y-4">
            <div class="relative">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                شناسه ملی شرکت
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                  </svg>
                </div>
                <input
                  v-model="companyNationalId"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  placeholder="شناسه ملی شرکت"
                  class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  style="border: 1px solid #d1d5db !important;"
                  @input="onCompanyNationalIdInput"
                />
              </div>

              <div v-if="companySearching" class="mt-2 text-xs text-blue-600">
                در حال جستجو...
              </div>
              <div
                v-else-if="companyResults.length"
                class="mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto"
              >
                <button
                  v-for="(item, index) in companyResults"
                  :key="index"
                  type="button"
                  class="w-full text-right px-3 py-2 hover:bg-blue-50 border-b border-gray-100 last:border-b-0"
                  @click="selectCompany(item)"
                >
                  <div class="text-sm text-gray-900">{{ getCompanyTitle(item) }}</div>
                  <div class="text-xs text-gray-500">{{ getCompanyNationalId(item) }}</div>
                </button>
              </div>
              <div
                v-else-if="companySelected"
                class="mt-2 text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-3 py-2"
              >
                شرکت یافت شد و اطلاعات پر شد.
              </div>
              <div
                v-else-if="companySearched && companyNationalId.length >= 9"
                class="mt-2 text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2"
              >
                شرکت یافت نشد — شرکت جدید است. نام شرکت را وارد کنید.
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                نام شرکت
                <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <input
                  v-model="companyLegalTitle"
                  type="text"
                  placeholder="نام شرکت"
                  :readonly="companySelected"
                  class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  :class="{ 'bg-gray-50': companySelected }"
                  style="border: 1px solid #d1d5db !important;"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="confirmInvoiceAndContinue()"
          >
            ورود اطلاعات
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="dialog_invoice_type=false"
          >
            انصراف
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        request_info: [],
        request_statuses: [],
        pre_req_status_summary: "",
        selected_pre_req_status: 0,
        dialog_change_pre_req_status: false,
        req_tech_refer_summary: "",
        dialog_accept_refer: false,
        show_reject_area: false,
        show_final_confirm: false,
        show_confirmation_dialog: false,
        show_confirmation_reject_area: false,
        confirmation_reject_summary: '',
        reject_summary_tried: false,
        request_confirmed: false,
        pre_req_status_list: [],
        action_button_text: '',
        next_action_status: 0,
        dialog_service_out_branch: false,
        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',

        current_lat:'',
        current_lng:'',
        source_location_lat:'',
        source_location_lng:'',

        dialog_invoice_type: false,
        invoiceType: '',
        companyNationalId: '',
        companyLegalTitle: '',
        companyResults: [],
        companySearching: false,
        companySearched: false,
        companySelected: false,
        companyFillingFromApi: false,
        companySearchTimer: null,
        companySearchSeq: 0,
      }
    },
    computed: {
      hasRejectSummary () {
        return String(this.confirmation_reject_summary || '').trim() !== ''
      },
      rejectSummaryInvalid () {
        return this.reject_summary_tried && !this.hasRejectSummary
      },
      isPendingReferAccept () {
        var info = this.request_info || {}
        var ar = info.AcceptRefer
        if (ar == 10 || ar == '10') return true
        if (ar == 0 || ar == '0') return false
        // اگر AcceptRefer مشخص نیست ولی وضعیت هنوز ارجاع است
        if (ar == null || ar === '') {
          var last = String(info.LastStatus || '')
          return last.indexOf('ارجاع') !== -1
        }
        return false
      },
      showReferConfirmCard () {
        return this.isPendingReferAccept || this.show_confirmation_dialog
      }
    },
    watch: {
      selected_province: function () {
        this.get_cities()
      },
      invoiceType: function (newVal) {
        if (newVal !== 'official') {
          this.resetCompanyFields()
        }
      }
    },
    mounted () {
  this.get_current_location()

  // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      this.get_statuses()
      this.get_request_info()
      this.check_if_confirmed_before()
      // this.get_provinces()
    },
    beforeDestroy () {
      if (this.companySearchTimer) {
        clearTimeout(this.companySearchTimer)
      }
    },
    methods: {
      isReferRejected (info) {
        if (!info) return false
        var ar = info.AcceptRefer
        return ar == 0 || ar == '0'
      },
      check_if_confirmed_before() {
        const req_id = this.$route.params.rec_id;
        const confirmed_requests = JSON.parse(localStorage.getItem('confirmed_requests') || '{}');
        if (confirmed_requests[req_id]) {
          this.show_confirmation_dialog = false;
          this.request_confirmed = true;
        } else {
          this.show_confirmation_dialog = true;
          this.request_confirmed = false;
        }
      },
      onAcceptRefer () {
        if (this.isPendingReferAccept) {
          this.req_tech_refer_summary = this.req_tech_refer_summary || ''
          this.accept_refer_tech(1)
          return
        }
        this.confirm_request()
      },
      confirm_request() {
        this.show_confirmation_dialog = false
        this.show_confirmation_reject_area = false
        this.confirmation_reject_summary = ''
        this.request_confirmed = true
        const req_id = this.$route.params.rec_id
        const confirmed_requests = JSON.parse(localStorage.getItem('confirmed_requests') || '{}')
        confirmed_requests[req_id] = true
        localStorage.setItem('confirmed_requests', JSON.stringify(confirmed_requests))
      },
      openConfirmationReject () {
        this.confirmation_reject_summary = ''
        this.reject_summary_tried = false
        this.show_confirmation_reject_area = true
      },
      cancelConfirmationReject () {
        this.show_confirmation_reject_area = false
        this.confirmation_reject_summary = ''
        this.reject_summary_tried = false
      },
      submitConfirmationReject () {
        this.reject_summary_tried = true
        var summary = String(this.confirmation_reject_summary || '').trim()
        if (!summary) {
          bus.$emit('show_toast', [2000, 'وارد کردن توضیحات لغو اجباری است'])
          return
        }
        this.req_tech_refer_summary = summary
        this.accept_refer_tech(0)
      },
      reject_request() {
        this.$router.go(-1)
      },
      safeParseArray(val) {
        try {
          if (!val) return []
          if (Array.isArray(val)) return val
          const parsed = JSON.parse(val)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      },
      hasValue (val) {
        if (val == null || val === '') return false
        if (typeof val === 'string' && val.trim() === '') return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      },
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' ,'
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' ,'
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }

        return address
      },
      go_direction (item,state) {
        // var url = 'geo:0,0?q=' + item.Lat + ',' + item.Lng
        // var url = 'https://www.google.com/maps/@' + item.Lat +','+item.Lng+',17z'
        // var url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`
        var url = ""
        if(state==1){
          url = `https://maps.google.com/?q=${item.Lat},${item.Lng}`

        }
        if(state==2){
          url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`

        }
        if(state==3){
          url = `https://nshn.ir/?lat=${item.Lat}&lng=${item.Lng}`
        }
        window.open(url, '_blank')
      },
      get_request_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UserReqDash', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_info = response.data.recordInfo || {}
              self.get_device_status()
              self.$route.meta.name = self.$t('showPreRequest') + self.request_info.RequestCode

              if (self.isReferRejected(self.request_info)) {
                bus.$emit('show_toast', [3000, 'ارجاع درخواست توسط شما رد شده است'])
                self.$router.go(-1)
                return
              }

              var ar = self.request_info.AcceptRefer
              var pending = (ar == 10 || ar == '10')
              if (!pending && (ar == null || ar === '')) {
                var last = String(self.request_info.LastStatus || '')
                pending = last.indexOf('ارجاع') !== -1
              }
              self.dialog_accept_refer = pending
              // اگر ارجاع هنوز در انتظار تایید است، کارت سوال را نشان بده
              if (pending) {
                self.show_confirmation_dialog = true
                self.request_confirmed = false
              }
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_statuses () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreReqStatusForTech', send_data, {})
          .then(response => {
              self.pre_req_status_list = response.data.StatusList;
          }).catch(e => {
          this.errors.push(e)
        })
      },
      openInvoiceTypeDialog () {
        this.invoiceType = ''
        this.resetCompanyFields()
        this.dialog_invoice_type = true
      },
      confirmInvoiceAndContinue () {
        if (!this.validateInvoiceAndCompany()) {
          return
        }
        this.dialog_invoice_type = false
        this.get_request_full_info()
      },
      resetCompanyFields () {
        this.companyNationalId = ''
        this.companyLegalTitle = ''
        this.companyResults = []
        this.companySearching = false
        this.companySearched = false
        this.companySelected = false
        this.companyFillingFromApi = false
        if (this.companySearchTimer) {
          clearTimeout(this.companySearchTimer)
          this.companySearchTimer = null
        }
      },
      getCompanyTitle (item) {
        if (!item) return ''
        return item.LegalTitle != null ? String(item.LegalTitle) : ''
      },
      getCompanyNationalId (item) {
        if (!item) return ''
        return item.NationalID != null ? String(item.NationalID) : ''
      },
      parseCompaniesResponse (raw) {
        let data = raw
        if (data == null) return []

        if (typeof data === 'string') {
          const trimmed = data.trim()
          if (!trimmed) return []
          try {
            data = JSON.parse(trimmed)
          } catch (e) {
            return []
          }
        }

        if (Array.isArray(data)) return data

        if (typeof data !== 'object') return []

        const candidates = [data.items, data.Items, data.data, data.Data, data.result, data.Result]
        for (let i = 0; i < candidates.length; i++) {
          let value = candidates[i]
          if (value == null) continue
          if (typeof value === 'string') {
            try {
              value = JSON.parse(value)
            } catch (e) {
              continue
            }
          }
          if (Array.isArray(value)) return value
        }

        return []
      },
      onCompanyNationalIdInput () {
        if (this.companyFillingFromApi) return

        this.companySelected = false
        this.companyLegalTitle = ''
        this.companyResults = []
        this.companySearched = false

        if (this.companySearchTimer) {
          clearTimeout(this.companySearchTimer)
        }

        const srch = this.persian_to_english((this.companyNationalId || '').trim())
        if (srch.length < 9) {
          this.companySearching = false
          return
        }

        this.companySearchTimer = setTimeout(() => {
          this.searchCompanies(srch)
        }, 1000)
      },
      searchCompanies (srchTxt) {
        this.companySearchSeq += 1
        const seq = this.companySearchSeq
        this.companySearching = true
        this.companySearched = false
        const user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          PageNo: 1,
          SrchTxt: srchTxt,
        }
        this.axios.post('/GetCompanies', send_data, { show_pros: false })
          .then(response => {
            if (seq !== this.companySearchSeq) return

            const items = this.parseCompaniesResponse(response.data)
            this.companyResults = items
            this.companySearched = true
            this.companySelected = false
            this.companyLegalTitle = ''
          })
          .catch(() => {
            if (seq !== this.companySearchSeq) return
            this.companyResults = []
            this.companySearched = true
            this.companySelected = false
          })
          .finally(() => {
            if (seq !== this.companySearchSeq) return
            this.companySearching = false
          })
      },
      selectCompany (item) {
        if (!item) return
        this.companyFillingFromApi = true
        this.companyNationalId = this.getCompanyNationalId(item)
        this.companyLegalTitle = this.getCompanyTitle(item)
        this.companySelected = true
        this.companyResults = []
        this.companySearched = true
        this.$nextTick(() => {
          this.companyFillingFromApi = false
        })
      },
      validateInvoiceAndCompany () {
        if (!this.invoiceType) {
          bus.$emit('show_dialog', ['خطا', 'لطفا نوع فاکتور را انتخاب کنید'])
          return false
        }
        if (this.invoiceType === 'official') {
          const nationalId = this.persian_to_english((this.companyNationalId || '').trim())
          const legalTitle = (this.companyLegalTitle || '').trim()
          if (!nationalId || !legalTitle) {
            bus.$emit('show_dialog', ['خطا', 'لطفا نام شرکت و شناسه ملی شرکت را وارد کنید'])
            return false
          }
        }
        return true
      },
      applyInvoiceToPassingData (passing_data) {
        passing_data.invoice_type = this.invoiceType
        if (this.invoiceType === 'official') {
          const nationalId = this.persian_to_english((this.companyNationalId || '').trim())
          const legalTitle = (this.companyLegalTitle || '').trim()
          passing_data.LegalTitle = legalTitle
          passing_data.NationalID = nationalId
          passing_data.is_company = true
        } else {
          passing_data.LegalTitle = ''
          passing_data.NationalID = ''
          passing_data.is_company = false
        }
        return passing_data
      },
      addCompanyFrmReq () {
        if (this.invoiceType !== 'official') {
          return Promise.resolve()
        }
        const user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          LegalTitle: (this.companyLegalTitle || '').trim(),
          NationalID: this.persian_to_english((this.companyNationalId || '').trim()),
        }
        return this.axios.post('/AddCompanyFrmReq', send_data, {})
      },
      navigateAfterInvoice (PassingData) {
        var self = this
        this.addCompanyFrmReq()
          .then(() => {
            if (PassingData.ServiceOutBranch == true) {
              self.dialog_service_out_branch = true
            } else {
              self.$router.push({ name: 'groups', params: {} })
            }
          })
          .catch(() => {
            if (PassingData.ServiceOutBranch == true) {
              self.dialog_service_out_branch = true
            } else {
              self.$router.push({ name: 'groups', params: {} })
            }
          })
      },
      get_request_full_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreReqRecInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.request_info = response.data.recordInfo;
              // self.get_device_status();
              var PassingData = { on_site_service: true }
              PassingData.ServiceOutBranch = response.data.recordInfo.ServiceOutBranch
              PassingData.ServiceOutBranchOnFinalize = '0'
              PassingData.PreRequestId = response.data.recordInfo.Id
              PassingData.on_site_service = true
              PassingData.cat_id = response.data.recordInfo.ProductTypeId
              PassingData.group_id = response.data.recordInfo.CategoryId
              PassingData.sub_group_id = response.data.recordInfo.GroupId
              PassingData.brand_id = response.data.recordInfo.SubGroupId
              PassingData.customer_summary = response.data.recordInfo.Description
              PassingData.model_id = response.data.recordInfo.ModelId
              PassingData.model_title = response.data.recordInfo.ModelTitle
              PassingData.other_phone_code = response.data.recordInfo.OtherPhoneCode
              PassingData.other_phone_no = response.data.recordInfo.OtherPhoneNO
              PassingData.customer_mobile = response.data.recordInfo.PhoneNO
              PassingData.customer_name = ''
              PassingData.stateId = 'final_pre_request'
              // data.put("typeId", String.valueOf(model.getRec().getProductTypeId()));
              // data.put("parentTitle", "درخواست");
              // data.put("stateId", "editrequest");
              // data.put("customer_name", "");
              // data.put("delivery_status", "true");
              PassingData.request_name = self.$t('repair')
              PassingData = self.applyInvoiceToPassingData(PassingData)

              localStorage.setItem('request_data', JSON.stringify(PassingData))
              console.log(PassingData)
              self.navigateAfterInvoice(PassingData)
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      service_out_branch_action (type) {
// console.log(type,this.request_statuses);
        var data = JSON.parse(localStorage.getItem('request_data'))
        data.ServiceOutBranchOnFinalize = this.request_statuses[type]
        localStorage.setItem('request_data', JSON.stringify(data))

        this.$router.push({ name: 'groups', params: {} })
      },
      go_to_categories () {
        var has_exist = false
        var self = this
        // console.log("statuses is "+JSON.stringify(this.request_statuses));
        var has_exist = false
        self.request_statuses.forEach(function (number) {
          if (self.request_info.StatusId == number) {
            has_exist = true
          }
        })
        if (!has_exist) {
          self.action_button_text = this.$t('startDrive')
          self.next_action_status = self.request_statuses[0]
          // ابتدا لوکیشن کاربر را بگیر، سپس درخواست را اجرا کن
          self.get_current_location()
            .then(() => {
              self.get_last_user_location(self.next_action_status)
            })
            .catch(() => {
              // اگر لوکیشن گرفته نشد، باز هم ادامه بده با آخرین لوکیشن
              self.get_last_user_location(self.next_action_status)
            })
          return
        }

        if (self.request_info.StatusId == self.request_statuses[0]) {
          self.action_button_text = this.$t('acceptReceiveFromCustomer')
          self.next_action_status = self.request_statuses[1]
          // ابتدا لوکیشن کاربر را بگیر، سپس درخواست را اجرا کن
          self.get_current_location()
            .then(() => {
              self.get_last_user_location(self.next_action_status)
            })
            .catch(() => {
              // اگر لوکیشن گرفته نشد، باز هم ادامه بده با آخرین لوکیشن
              self.get_last_user_location(self.next_action_status)
            })
          return
        }

        if (self.request_info.StatusId == self.request_statuses[1] || self.request_info.StatusId == self.request_statuses[16]) {
          self.action_button_text = this.$t('finalizeRequest')
          self.next_action_status = self.request_statuses[1]
          self.openInvoiceTypeDialog()
          return false
        }

        // برای سایر حالات هم ابتدا لوکیشن بگیر
        self.get_current_location()
          .then(() => {
            self.change_request_status(self.next_action_status)
          })
          .catch(() => {
            // اگر لوکیشن گرفته نشد، باز هم ادامه بده
            self.change_request_status(self.next_action_status)
          })
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            var has_exist = false
            self.request_statuses.forEach(function (number) {
              if (self.request_info.StatusId == number) {
                has_exist = true
              }
            })
            if (!has_exist) {
              self.action_button_text = self.$t('startDrive')
              self.next_action_status = self.request_statuses[0]
            } else if (self.request_info.StatusId == self.request_statuses[0]) {
              self.action_button_text = self.$t('acceptReceiveFromCustomer')
              self.next_action_status = self.request_statuses[1]
            } else if (self.request_info.StatusId == self.request_statuses[1] || self.request_info.StatusId == self.request_statuses[16]) {
              self.action_button_text = self.$t('finalizeRequest')
              self.next_action_status = self.request_statuses[1]
            } else {
              self.action_button_text = ''
              self.next_action_status = 0
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_request_status (status_id) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          StatusId: status_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangePreRequestStatus', send_data, {})
          .then(response => {
            self.get_request_info()
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_pre_request_status_tech () {
        if(this.selected_pre_req_status==0){
          bus.$emit('show_toast', [2000, "یک وضعیت انتخاب کنید"])

          return
        }
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          PreReqId: this.$route.params.rec_id,
          Desc: this.pre_req_status_summary,
          StatusId: this.selected_pre_req_status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddPreReqStatusByTech', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
if(response.data.error==0){
  self.dialog_change_pre_req_status=false;
}
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_current_location(){
        // This will open permission popup
        var self = this
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            bus.$emit('show_toast', [2000, "مرورگر شما از موقعیت‌یابی پشتیبانی نمی‌کند"])
            reject(new Error('Geolocation not supported'))
            return
          }
          
          navigator.geolocation.getCurrentPosition(
            function (position) {
              self.current_lat = position.coords.latitude;
              self.current_lng = position.coords.longitude;
              console.log('Location obtained:', self.current_lat, self.current_lng)
              resolve({
                lat: self.current_lat,
                lng: self.current_lng
              })
            },
            function (error) {
              console.log('error location is', error)
              bus.$emit('show_toast', [2000, "خطا در دریافت موقعیت مکانی"])
              reject(error)
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0
            }
          )
        })
      },
      get_last_user_location(status) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLastLocationByUserId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.source_location_lat = response.data.Lat;
              self.source_location_lng = response.data.Lng;
              // this.branch_id = response.data.UserBranchId
            }else{
              self.get_current_location();
              self.source_location_lat = self.current_lat;
              self.source_location_lng = self.current_lng;
            }
            self.get_snapp_price(status);

          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_snapp_price(status) {
        var self = this

        self.source_location_lat="35.732846"
        self.source_location_lng="51.373192"
        if(self.source_location_lat==null || self.source_location_lat==""){
          bus.$emit('show_toast', [1500, "موقعیت مکانی یافت نشد"])
          return
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        // const send_data = {
        //   source_lat:self.source_location_lat,
        //   source_lng:self.source_location_lng,
        //   dest_lat:self.request_info.Addresses[0].Lat,
        //   dest_lng:self.request_info.Addresses[0].Lng
        // }
        var formData = new FormData();
        formData.append('source_lat',self.source_location_lat);
        formData.append('source_lng',self.source_location_lng);
        formData.append('dest_lat',self.request_info.Addresses[0].Lat);
        formData.append('dest_lng',self.request_info.Addresses[0].Lng);
        // console.log("send data snapp",send_data)
var url = 'https://cp.zoodkomak.com/api/get_user_locations_price';
        // var config = {
        //   method: 'post',
        //   url: url,
        //
        //   data : send_data
        // };

        this.axios.post(url,formData,{})
          .then(function (response) {
            console.log(response.data.time);
            self.change_request_status_with_price(status,response.data.time,response.data.distance);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      change_request_status_with_price(status_id,price,distance) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          ReqType: 0,
          StatusId: status_id,
          SourceLat: self.source_location_lat,
          SourceLng: self.source_location_lng,
          DestLat: self.request_info.Addresses[0].Lat,
          DestLng: self.request_info.Addresses[0].Lng,
          RouteTime: price,
          Distance:distance,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangePreRequestStatusWithPrice', send_data, {})
          .then(response => {
            self.get_request_info()
            if (status_id == self.request_statuses[4]) {
              // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
              self.$router.push({name: 'signature', params: {rec_id: self.$route.params.rec_id, type_id: 5}})
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      accept_refer_tech(status) {
        if (status == 0 && String(this.req_tech_refer_summary || '').trim() === '') {
          bus.$emit('show_toast', [2000, 'وارد کردن توضیحات لغو اجباری است'])
          return
        }
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          RecStatusId: this.request_info.RecStatusId,
          ProcessType: 0,
          ItemDesc: this.req_tech_refer_summary,
          AcceptType: status,
        }

        this.axios.post('/AddProcessReferAccept', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.show_confirmation_reject_area = false
              self.show_confirmation_dialog = false
              self.dialog_accept_refer = false
              self.request_confirmed = true
              const req_id = self.$route.params.rec_id
              const confirmed_requests = JSON.parse(localStorage.getItem('confirmed_requests') || '{}')
              confirmed_requests[req_id] = true
              localStorage.setItem('confirmed_requests', JSON.stringify(confirmed_requests))
              if (status == 0) {
                self.$router.go(-1)
              } else {
                self.get_request_info()
              }
            } else if (response.data && response.data.msg) {
              bus.$emit('show_toast', [2500, response.data.msg])
            }
          }).catch(e => {
            this.errors.push(e)
          })
      },
  }
  }
</script>
<style scoped>
.pre-req {
  padding: 12px;
  background: #f8fafc;
}
.page-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 8px 0 16px 0;
}
.info-list { list-style: none; padding: 0; margin: 0 0 12px 0; }
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
}
.info-item label { color: #475569; font-size: 13px; }
.info-item span { color: #0f172a; font-size: 13px; }
.call-btn { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); }

.section-title { display: block; margin: 10px 0; font-weight: 600; color: #0f172a; }

.request_detail_ul {
  list-style: none;
  padding: 0;
  margin: 0 0 12px 0;
}

.request_detail_ul>li {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
}

/* For list items with label beside span */
.request_detail_ul>li:has(> label) {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* For list items with div containing label */
.request_detail_ul>li:has(> div) {
  display: block;
}

.request_detail_ul>li > div {
  width: 100%;
}

.request_detail_ul>li > div > label {
  display: block;
  color: #475569;
  font-size: 13px;
  margin-bottom: 8px;
}

.request_detail_ul>li label {
  color: #475569;
  font-size: 13px;
}

.request_detail_ul>li span {
  color: #0f172a;
  font-size: 13px;
}

.request_detail_ul>hr {
  display: none;
}

.address-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 10px;
}
.address-text { margin: 0 0 6px 0; color: #0f172a; }
.address-phone { color: #64748b; font-size: 12px; }
.time-range { display: inline-block; margin-top: 6px; color: #475569; font-size: 12px; }

.chip-btn {
  display: inline-block;
  padding: 8px 10px;
  border-radius: 20px;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  font-size: 12px;
}
.chip-btn:hover { background: #dbeafe; }

.primary-btn {
  padding: 12px;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  border: 0;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 12px;
  padding-bottom: 70px;
}
.secondary-btn {
  width: 100%;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: #0f172a;
  font-weight: 600;
  margin-top: 8px;
}

/* Dialog base from other pages */
.plain-dialog {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.dialog1-card {
  width: 92%;
  max-width: 520px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.18);
  overflow: hidden;
}
.dialog-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}
.dialog-header .name { font-weight: 700; }
.dialog-close {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 24px;
  line-height: 32px;
  cursor: pointer;
}
.dialog-close:hover { color: #0f172a; }
.plain-input {
  width: 100%;
  min-height: 48px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: #0f172a;
}

.inline-refer-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin: 10px 0;
}

.inline-refer-header {
  padding: 10px 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  color: #fff;
  text-align: center;
}

.inline-refer-body {
  padding: 12px 14px;
}

.btn-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-accept {
  padding: 10px 14px;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
}
.btn-accept:hover { filter: brightness(1.05); }

.btn-reject {
  padding: 10px 14px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
}
.btn-reject:hover { filter: brightness(1.05); }
</style>
<style scoped>
.inline-refer-card { background:#fff; border:1px solid #e5e7eb; border-radius:12px; overflow:hidden; margin:10px 0; }
.inline-refer-header { padding:10px 14px; font-weight:700; background:linear-gradient(135deg,#1c39bb,#2563eb); color:#fff; text-align:center; }
.inline-refer-body { padding:12px 14px; }
.btn-accept { padding:10px 14px; background:linear-gradient(135deg,#1c39bb,#2563eb); color:#fff; border:none; border-radius:10px; font-weight:600; }
.btn-reject { padding:10px 14px; background:linear-gradient(135deg,#ef4444,#dc2626); color:#fff; border:none; border-radius:10px; font-weight:600; }
.secondary-btn { padding:10px 14px; background:#fff; border:1px solid #e5e7eb; border-radius:10px; font-weight:600; }
.final-confirm { background:#f8fafc; border:1px dashed #cbd5e1; border-radius:10px; padding:10px; }
</style>
